import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { glb_sv } from 'src/utils';

function EmtyData() {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <img
                style={{
                    width: '25%',
                }}
                src={`${glb_sv.domain}/upload/product/search-engine.png`}
                alt="Emty Data"
            />
            {/* <Typography variant="body1" color={'error'} sx={{ fontStyle: 'italic' }}>
                {t('emty_data')}!
            </Typography> */}
        </Box>
    );
}

export default EmtyData;
